var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v2-stepper"},_vm._l((_vm.total),function(i){return _c('div',{key:i,class:[
      'v2-stepper__dot',
      {
        'v2-stepper__dot--completed': _vm.step > i,
        'v2-stepper__dot--active': _vm.step === i,
      }
    ]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }